import type { EntityViewType } from "@config";
import { useMemo } from "react";
import { type ITimelineSettings, TimelineTypeEnum } from "../types";

interface IProps {
  entity: EntityViewType;
  isMobile: boolean;
}

export const useTimelineItemsInView = ({ entity, isMobile }: IProps) => {
  const comboSettings = entity.settings as ITimelineSettings;
  const amtOfSets = entity.children.length;

  return useMemo<number>(() => {
    if (
      isMobile ||
      comboSettings.timelineType !== TimelineTypeEnum.Horizontal
    ) {
      return 1;
    }

    // auto: 1 slide on narrow, 2 elsewhere. User picks higher density
    // via the popover stepper.
    if (typeof comboSettings.timelineSetsPerSlide !== "number") {
      if (comboSettings.maxWidth === "narrow") {
        return Math.min(1, amtOfSets);
      }

      return Math.min(2, amtOfSets);
    }

    const parsed = Number(comboSettings.timelineSetsPerSlide);
    if (Number.isNaN(parsed)) return 3;
    return Math.min(6, parsed);
  }, [
    isMobile,
    comboSettings.timelineType,
    comboSettings.timelineSetsPerSlide,
    comboSettings.maxWidth,
    amtOfSets,
  ]);
};
